import React from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from 'reactstrap'
import { useSnackbar } from 'notistack'
import { useDeleteStaffMutation } from '../farmers-list/farmersListApiSlice'
import CustomButton from 'components/Buttons/CustomButton'

const ModalDeleteStaff = ({ isOpen, toggle, selectedRow, onSuccess }) => {
  const { enqueueSnackbar } = useSnackbar()
  const [deleteStaff, { isLoading: isDeleting }] = useDeleteStaffMutation()

  const handleSubmit = async () => {
    try {
      await deleteStaff({
        "id": selectedRow?.id,
        "code": selectedRow?.code
      }).unwrap()

      enqueueSnackbar('Berhasil menghapus anggota', { variant: 'success' })
      toggle()
      if (onSuccess) onSuccess()
    } catch (error) {
      enqueueSnackbar(
        error?.data?.message || error?.data?.meta?.message || 'Terjadi kesalahan',
        { variant: 'error' },
      )
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered data-testid="farmer-delete-staff-modal">
      <ModalHeader toggle={toggle}>Hapus Anggota</ModalHeader>
      <ModalBody>
        <p className="mb-0">
          Apakah Anda yakin ingin menghapus <strong>{selectedRow?.name}</strong> dari grup ini? Anggota yang dihapus tidak dapat mengakses grup ini lagi.
        </p>
      </ModalBody>
      <ModalFooter>
        <CustomButton
          color="secondary"
          className="btn-cancel"
          outline
          onClick={toggle}
          disabled={isDeleting}
          testId="farmer-delete-staff-cancel-button"
        >
          Batal
        </CustomButton>
        <CustomButton
          color="danger"
          onClick={handleSubmit}
          disabled={isDeleting}
          testId="farmer-delete-staff-submit-button"
        >
          {isDeleting ? <Spinner size="sm" /> : 'Hapus'}
        </CustomButton>
      </ModalFooter>
    </Modal>
  )
}

export default ModalDeleteStaff
